import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/schlix': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2zM192 122.1l45.7-28.2 34.7 34.6-55.4 29zM126.9 128.7l31.9-22.1 17.2 28.4-36.7 22.5zM103.6 216.9l-8.8-34.8 29.6-18.3 13.1 35.3zM82.4 133.2l23.9-18.1 8.9 24-26.7 18.3zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7zM28.4 223.1l20.8-12.8 3.3 33.4-22.9 12zM1.4 268l19.2-10.2 0.4 38.2-21 8.8zM60.5 327.3l-28.3 8.3-1.6-46.8 25.1-10.7zM99 263.2l-31.1 13-5.2-40.8 27.4-14.4zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8zM151.7 237.1l21.2 57.1-46.2 13.6-13.7-54.1zM237.4 467.6l-70.9-3.3-24.3-95.8 55.2-8.6zM152.5 187.9l42.2-22.4 28 45.9-50.8 21.3zM193.5 282.8l61.3-18.7 52.8 86.6-79.8 11.3zM244.9 197.2l67.3-28.8 65.5 65.4-88.6 26.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/schlix.js
// module id = 1002
// module chunks = 0